import Icon from 'components/Icon';

import { motion } from 'framer-motion';

import './style.css';

const dropIn = {
	hidden: {
		x: '-50%',
		y: '-100vh',
		opacity: 0,
	},
	visible: {
		opacity: 1,
		y: '-50%',
		x: '-50%',
		transition: {
			duration: 0.1,
			type: 'spring',
			damping: 25,
			stiffness: 300,
		},
	},
	exit: {
		y: '100vh',
		opacity: 0,
	},
};

const Modal = ({ children, isVisible, setVisibility, closeIconColor = '#9a9a9a', extraClassName, backHome, hideCloseButton = false }) => {
	if (isVisible) {
		return (
			<div className={`Modal ${extraClassName || ''}`}>
				<motion.div className="Modal__content" variants={dropIn} initial="hidden" animate="visible" exit="exit">
					{!hideCloseButton && (
						<div className="Modal__close_btn">
							<Icon icon="closeIcon" onClick={setVisibility} color={closeIconColor} />
						</div>
					)}
					{backHome && typeof backHome === 'function' && (
						<div className="Modal__back_home">
							<Icon icon="houseIcon" onClick={backHome} color={closeIconColor} size={16} />
						</div>
					)}
					{children}
				</motion.div>
			</div>
		);
	}
	return null;
};

export default Modal;
